exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-style-print {\n  width: 500px;\n  height: 300px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/company-structure-picture/company-structure-picture.component.scss
// module id = ../../../../../src/app/securities-level/company-structure-picture/company-structure-picture.component.scss
// module chunks = main